import { render, staticRenderFns } from "./Storemap.vue?vue&type=template&id=5cafcdc9&scoped=true"
import script from "./Storemap.vue?vue&type=script&lang=js"
export * from "./Storemap.vue?vue&type=script&lang=js"
import style0 from "./Storemap.vue?vue&type=style&index=0&id=5cafcdc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cafcdc9",
  null
  
)

export default component.exports